import script from "./previsualizacion.vue?vue&type=script&setup=true&lang=js"
export * from "./previsualizacion.vue?vue&type=script&setup=true&lang=js"

import "./previsualizacion.vue?vue&type=style&index=0&id=14739fee&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14739fee"]])

export default __exports__